import { createSlice } from '@reduxjs/toolkit';

import {
  actualizePackageAction,
  actualizePackageSuccess,
  actualizePackageFail,
  showPriceChanged,
  hidePriceChanged,
  startActualizationProcessAction,
  stopActualizationProcessAction,
  setFrontErrorAction,
} from '../actions/actualization';
import { clearPreviousPackageDataAction } from '../actions/package';

import type { ActualizationStateType } from '../actualization/types';

const initialState: ActualizationStateType = {
  fetching: false,
  lastUpdated: null,
  error: null,
  success: null,
  rotten: false,
  ordered: false,
  showPriceChanged: false,
  isActualizationProcess: false,
  exception: null,
  frontError: null,
  show_modal_customer: false,
  hotelFacts: null,
  changes: {},
  prebook_data: {},
  cache_level: null,
  exclude_operator: null,
  flight_options: null,
  meta_policies: null,
  package: {},
};

export const actualizationSlice = createSlice({
  name: 'actualization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(startActualizationProcessAction, (state) => ({
        ...state,
        isActualizationProcess: true,
      }))
      .addCase(stopActualizationProcessAction, (state) => ({
        ...state,
        isActualizationProcess: false,
      }))
      .addCase(actualizePackageAction, (state) => ({
        ...state,
        fetching: true,
      }))
      .addCase(actualizePackageSuccess, (state, { payload }) => {
        const {
          lastUpdated,
          show_modal_customer,
          data: { rotten = false, changes, prebook_data, package: pckg },
        } = payload;
        const hotelFacts = pckg?.hotel?.facts || null;

        return {
          ...state,
          lastUpdated,
          success: true,
          rotten,
          fetching: false,
          changes,
          prebook_data,
          hotelFacts,
          show_modal_customer,
        };
      })
      .addCase(actualizePackageFail, (state, { payload }) => {
        const {
          lastUpdated,
          ordered = false,
          rotten = false,
          exception = null,
        } = payload;

        return {
          ...state,
          success: false,
          fetching: false,
          lastUpdated,
          ordered,
          rotten,
          exception,
        };
      })
      .addCase(showPriceChanged, (state) => ({
        ...state,
        showPriceChanged: true,
      }))
      .addCase(hidePriceChanged, (state) => ({
        ...state,
        showPriceChanged: false,
      }))
      .addCase(clearPreviousPackageDataAction, () => initialState)
      .addCase(setFrontErrorAction, (state, { payload }) => ({
        ...state,
        frontError: payload,
      }));
  },
});

export default actualizationSlice.reducer;
